import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const Careers = lazy(() => import("@/pages/Careers"));

export const Route = createFileRoute("/_public/careers")({
  component: Careers,
});
